var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dms-view"},[_c('MdtNotify'),_c('MdtLightbox'),_c('UnprotectedViewHeader'),_c('div',{staticClass:"dms-view-content"},[_c('RouterView',{staticClass:"dms-view-router"})],1),_c('UnprotectedViewFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }